<template>
  <div class="mt-5 pt-3">
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        <strong> {{ $t('authForm.resetPass') }} </strong>
      </div>
      <div v-if="!isSuccessReset">
        <a-form class="mb-4" :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              size="large"
              :placeholder="$t('authForm.emailAddress')"
              v-decorator="['email', {rules: [{ required: true, message: $t('authForm.requiredEmail') }]}]"
            />
          </a-form-item>
          <div>
            <a-button
              htmlType="submit"
              size="large"
              type="primary"
              class="text-center w-100"
              :loading="loading"
            >
              <strong> {{ $t('authForm.resetMyPass') }} </strong>
            </a-button>
          </div>
        </a-form>
      </div>
      <div v-if="isSuccessReset">
        <a-alert
          :message="msgAlert.message"
          :description="msgAlert.description"
          type="success"
          show-icon
          closable
          :after-close="() => isSuccessReset = false"
        />
      </div>
      <router-link to="/auth/login" class="kit__utils__link font-size-16">
        <i class="fe fe-arrow-left mr-1 align-middle" />
        {{ $t('authForm.goToSignIn') }}
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'CuiForgotPassword',
  computed: {
    ...mapState(['settings', 'app']),
    ...mapGetters({ loginStatusCode: 'user/loginStatusCode' }),
    loading() {
      return this.$store.state.user.loading
    },
    // link() {
    //   return this.$store.state.user.confirmpass.link
    // },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      msgAlert: {
        message: '',
        description: '',
      },
      isSuccessReset: false,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('user/FORGOTPASS', values)
            .then(({ success, message }) => {
              if (success) {
                this.isSuccessReset = true
                this.msgAlert = {
                  message: this.$t('authForm.tankYou'),
                  description: this.$t('authForm.forgotpassSucces'),
                }
              } else {
                this.$notification.error({
                  message: this.$t('authForm.forgotpassFailed'),
                  description: message,
                })
              }
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
